<template>
  <div class="card">
    <div class="card-body">
      <h4 class="card-title cursor-pointer" v-on:click="toggleCollase()">
        <feather-icon :icon='!isAccordionOpen?"ChevronDownIcon":"ChevronUpIcon"'/>
        Filtros
      </h4>
      <b-collapse
        :id="'accordion-filters'"
        accordion="accordion-filters"
        role="tabpanel"
        block
        :visible="isAccordionOpen"
      >
        <div class="row">
          <div class="col-4">
            <vs-select
              autocomplete
              class="w-100"
              label="Desatendida"
              v-model="inDesAttended"
              @change="setFilter('aprobacionesAtendidas', inDesAttended)"
            >
              <vs-select-item value="*" text="Todo" />
              <vs-select-item value="desatendida:1" text="Si" />
              <vs-select-item value="desatendida:0" text="No" />
            </vs-select>
          </div>
          <div class="col-4">
            <vs-select
              autocomplete
              class="w-100"
              label="Está en curso"
              v-model="inProgress"
              @change="setFilter('aprobacionesActivas', inProgress)"
            >
              <vs-select-item value="*" text="Todo" />
              <vs-select-item value="aprobacionesActivas:>=1" text="Si" />
              <vs-select-item value="aprobacionesActivas:0" text="No" />
            </vs-select>
          </div>
          <div class="col-4">
            <vs-select
              autocomplete
              class="w-100"
              label="Unidad"
              v-model="unit"
              @change="setFilter('unidad', unit)"
            >
              <vs-select-item value="*" text="Todo" />
              <vs-select-item
                autocomplete
                :key="item.id"
                :value="`unidad:${item.id}`"
                :text="item.nombre"
                v-for="item in units"
              />
            </vs-select>
          </div>
          <div class="col-4">
            <vs-select
              autocomplete
              class="w-100"
              label="Tipo flujo"
              v-model="flowType"
              @change="setFilter('tipoEjecucion', flowType)"
            >
              <vs-select-item value="*" text="Todo" />
              <vs-select-item value="tipoEjecucion:N" text="Normal" />
              <vs-select-item value="tipoEjecucion:P" text="Por monto" />
            </vs-select>
          </div>
          <div class="col-4">
            <vs-select
              autocomplete
              class="w-100"
              label="Estado"
              v-model="active"
              @change="setFilter('aprobacionesEstado', active)"
            >
              <vs-select-item value="*" text="Todo" />
              <vs-select-item value="aprobacionesEstado:Y" text="Activas" />
              <vs-select-item value="aprobacionesEstado:N" text="Inactivas" />
            </vs-select>
          </div>
          <div class="col-4">
            <vs-select
              autocomplete
              class="w-100"
              label="Doc. Referencia"
              v-model="referenceDoc"
              @change="setFilter('tipoObjeto', referenceDoc)"
            >
              <vs-select-item value="*" text="Todo" />
              <vs-select-item
                autocomplete
                :key="item.opcionId"
                :value="`tipoObjeto:${item.valor}`"
                :text="item.descripcion"
                v-for="item in sortedReferenceApprovals"
              />
            </vs-select>
          </div>
          <div class="col-4">
            <vs-input
              class="w-100"
              label="Búsqueda por nombre"
              placeholder="Ej: Aprobación 455"
              v-model="name"
              @keyup.native="setFilter('nombre', `nombre$${name}`)"
            />
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Filters',
  data() {
    return {
      isAccordionOpen: true,
      app: '*',
      inDesAttended: '*',
      inProgress: '*',
      flowType: '*',
      unit: '*',
      referenceDoc: '*',
      name: '',
      active: 'aprobacionesEstado:Y'
    };
  },
  computed: {
    ...mapGetters('Approvals', ['referenceApprovals']),
    ...mapGetters('Empresas', [
      'groupsCompany',
      'empresa'
    ]),
    sortedReferenceApprovals() {
      // Sort by descripcion
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.referenceApprovals.sort((a, b) => {
        if (a.descripcion < b.descripcion) {
          return -1;
        }
        if (a.descripcion > b.descripcion) {
          return 1;
        }
        return 0;
      });
    },
    units() {
      return this.groupsCompany
        .filter((group) => group.esOficina === 'N' || group.esOficina === 'no' || !group.isOffice);
    }
  },
  methods: {
    ...mapActions('Empresas', ['getGroupsCompany']),
    setFilter(type, filter) {
      this.$root.$emit(`${type}`, {
        filterName: `${type}`,
        filter
      });
    },
    toggleCollase() {
      this.isAccordionOpen = !this.isAccordionOpen;
    }
  },
  created() {
    this.getGroupsCompany({
      empresaId: this.empresa.id
    });
  }
};
</script>
